import * as React from "react";

export const Tile = () => <rect width="16" height="16" rx="2" stroke="none" />;
